// 기본 창고 레이아웃 — 4열 × 5행 (총 16칸)
// ParkingLayoutDesigner 툴로 생성/수정 가능 (unit 타입 사용)

const layout = {
  meta: {
    cols: 4,
    rows: 5,
    label: '기본 창고',
  },
  cells: [
    { col: 0, row: 0, type: 'unit', unit_no: 'A01' },
    { col: 1, row: 0, type: 'unit', unit_no: 'A02' },
    { col: 2, row: 0, type: 'unit', unit_no: 'A03' },
    { col: 3, row: 0, type: 'unit', unit_no: 'A04' },

    { col: 0, row: 1, type: 'aisle' },
    { col: 1, row: 1, type: 'aisle' },
    { col: 2, row: 1, type: 'aisle' },
    { col: 3, row: 1, type: 'aisle' },

    { col: 0, row: 2, type: 'unit', unit_no: 'B01' },
    { col: 1, row: 2, type: 'unit', unit_no: 'B02' },
    { col: 2, row: 2, type: 'unit', unit_no: 'B03' },
    { col: 3, row: 2, type: 'unit', unit_no: 'B04' },

    { col: 0, row: 3, type: 'aisle' },
    { col: 1, row: 3, type: 'aisle' },
    { col: 2, row: 3, type: 'aisle' },
    { col: 3, row: 3, type: 'aisle' },

    { col: 0, row: 4, type: 'unit', unit_no: 'C01' },
    { col: 1, row: 4, type: 'unit', unit_no: 'C02' },
    { col: 2, row: 4, type: 'unit', unit_no: 'C03' },
    { col: 3, row: 4, type: 'entrance' },
  ],
};

export default layout;
